import { render, staticRenderFns } from "./show_info.vue?vue&type=template&id=4d2e457c&scoped=true&"
import script from "./show_info.vue?vue&type=script&lang=js&"
export * from "./show_info.vue?vue&type=script&lang=js&"
import style0 from "./show_info.vue?vue&type=style&index=0&id=4d2e457c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2e457c",
  null
  
)

export default component.exports